import axios from "axios";

// 本番ドメインで動作している場合は、環境変数より同じドメインを優先 (preview混入防止)
function resolveBackendUrl() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    // 本番ドメイン (shiftmagic.jp) や Emergent デプロイドメインの場合は同じ origin を使う
    if (host === "shiftmagic.jp" || host === "www.shiftmagic.jp" || host.endsWith(".emergent.host")) {
      return window.location.origin;
    }
  }
  return process.env.REACT_APP_BACKEND_URL;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // 代理ログインタブは sessionStorage を優先
  const token = sessionStorage.getItem("shift_token") || localStorage.getItem("shift_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      sessionStorage.removeItem("shift_token");
      sessionStorage.removeItem("shift_user");
      localStorage.removeItem("shift_token");
      localStorage.removeItem("shift_user");
      window.location.href = "/login";
    }
    if (err.response?.status === 402 && err.response?.data?.code === "subscription_blocked") {
      // SubscriptionGate に状態を再取得させる + トースト通知
      try {
        window.dispatchEvent(new CustomEvent("billing:refresh"));
        import("sonner").then(({ toast }) => {
          toast.error("無料期間が終了しています。クレジットカードを登録して再開してください。");
        });
      } catch { /* noop */ }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "エラーが発生しました";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" / ");
  return String(d);
}

export default api;
